import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { rootRoute } from '../../../config';
import info from '../assets/info.png';
import time_elapse_icon from '../../../assets/time_elapse_icon.png';
import Button from '../../common/Button'
import QmModuleStyle from '../styles/qm.module.css';

const SimProgress = ({ popupState, actions }) => {
  const navigate = useNavigate();
  const [playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation,isShowPlaceOrder] = actions;
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error,isRequestLoading, qmPopup, setQmPopup] = popupState;
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [pauseSimulationTop, setPauseSimulationTop] = useState(0);
  const intervalDuration = 10; // 1 second in milliseconds
  const totalTime = 100; // Total time in seconds
  const isLeapYear = (year) => {
    return ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) ? 366 : 365;
  }
  let popupStyle = {
    padding: "5px 15px",
    backgroundColor: "white",
    zIndex: 2,
  }
  const progressbar = { "valuemin": 0, "valuemax": isLeapYear(simObj?.laststate?.stateyear), "valuenow": function () { return (Math.round((simObj.currentstep / this.valuemax) * 100)) } }
  const showSummary = () => {
    setIsLoader(true);
    navigate(rootRoute + "/qm/summary");
  }
  const getShortMonth = (month) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
    return months[month - 1];
  }
  useEffect(()=>{((toggleSimulation) && simObj.status != 'COMPLETED' && error == null && currentTime == totalTime) && resumeSimulation();},[currentTime])
  useEffect(()=>{!isRequestLoading &&  setCurrentTime(0);},[isRequestLoading])
  useEffect(() => {
    let intervalId;
    if (isPlaying && currentTime < totalTime) {
      intervalId = setInterval(() => {
        setCurrentTime((prevTime) => prevTime + 1);
      }, intervalDuration);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isPlaying, currentTime, totalTime]);

  useEffect(()=>{(toggleSimulation) ? setIsPlaying(true) : setIsPlaying(false);},[toggleSimulation]);
  useEffect(() => {
    const handleResize = () => {
      if (document.querySelector(`.${QmModuleStyle.simProg}`) != null && window.innerWidth > 991) {
        let top = 0;
        if (document.querySelector(`.${QmModuleStyle['sim-progress-activity']} .${QmModuleStyle.posuccess}`) != null) {
          // top = document.querySelector(`.${QmModuleStyle._progress}`).clientHeight + document.querySelector(`.${QmModuleStyle.posuccess}`).clientHeight+12;
          top = 100;
          document.querySelector(`.${QmModuleStyle.ui}.${QmModuleStyle.pointing}.${QmModuleStyle.label}.${QmModuleStyle.simProg}`).style.top = top + "%";
        }
        else {
          top = document.querySelector(`.${QmModuleStyle._progress}`).clientHeight + document.querySelector(`.${QmModuleStyle._progress}`).offsetTop;
          document.querySelector(`.${QmModuleStyle.ui}.${QmModuleStyle.pointing}.${QmModuleStyle.label}.${QmModuleStyle.simProg}`).style.top = top + "px";
        }
        }
        if (document.querySelector(`.${QmModuleStyle['sim-progress-activity']} .${QmModuleStyle.posuccess}`) != null && window.innerWidth < 991 && document.querySelector(`.${QmModuleStyle.simProg}`) != null) {
          document.querySelector(`.${QmModuleStyle.ui}.${QmModuleStyle.pointing}.${QmModuleStyle.label}.${QmModuleStyle.simProg}`).style.left = "20%";
        }
        if(qmPopup?.pauseSimulation && document.getElementsByClassName("ui pointing label")[0] != null){
          // let top = document.getElementsByClassName("ui pointing label")[0].clientHeight + document.getElementsByClassName(`${QmModuleStyle["simmsg-container"]}`)[0].clientHeight - 15;
          let top = document.getElementsByClassName(`${QmModuleStyle['_progress']}`)[0].offsetTop + document.getElementsByClassName(`${QmModuleStyle['_progress']}`)[0].clientHeight;
          setPauseSimulationTop(top);
        }
      }
        window.addEventListener('resize', handleResize);
        handleResize();
  },[simPrgPopup, qmPopup?.pauseSimulation]);
  useEffect(()=>{
    if((simObj.status == 'COMPLETED') && (document.getElementById("showSummary") != null)){
      document.getElementById("showSummary").focus();
    }
  },[simObj.status])
  return (
    <div className={`${QmModuleStyle['sim-progress-activity']}`}>
      <div className={`${QmModuleStyle.pie}`} title={`${currentTime}% completed.`} style={{ '--p': (simObj.status == 'COMPLETED') ? 100 : currentTime, '--b': '10px', '--c': 'purple' }} role='progressbar'></div>
      <div className={`${QmModuleStyle._progress} ${simPrgPopup ? `show ${QmModuleStyle.show}` : ''}`}>
        <div className={`${QmModuleStyle['time-progress']}`}>
          <div className={`${QmModuleStyle['remain-time']}`}>
            {/* <img className={(toggleSimulation && simObj.status != 'COMPLETED') ? `${QmModuleStyle.spin}` : ''} src={time_elapse_icon} alt="" /> */}
            <span><strong>{getShortMonth(simObj?.laststate?.statemonth)} {simObj?.laststate?.stateday} </strong>({simObj?.laststate?.daysleft} days remaining)</span>
          </div>
          <div className={`ui progress indicating ${QmModuleStyle.progress} ${QmModuleStyle.ui}`}>
            <div className={`${QmModuleStyle['background']}`} id="time">
              <div role="progressbar"
                aria-valuenow={progressbar.valuenow()}
                aria-valuemin={progressbar.valuemin}
                aria-valuemax={progressbar.valuemax}
                aria-valuetext={`${progressbar.valuenow()}%`}
                className={` ${QmModuleStyle['progress-fg']} ${(toggleSimulation && simObj.status != 'COMPLETED') ? `${QmModuleStyle.active}` : ''}`} style={{ "width": progressbar.valuenow() + '%' }}></div>
            </div>
          </div>
        </div>
          {
            (toggleSimulation && simObj.status != 'COMPLETED') && <Button btnName="Pause Simulation" clickEventHandler={pauseSimulation} btnId="pauseSumButton" btnClass={`${(qmPopup?.pauseSimulation) ? `show ${QmModuleStyle['show']}` : ''}`} btnParentStyle={qmPopup?.pauseSimulation ? popupStyle : {}}/>
          }{
            (!toggleSimulation && simObj.status != 'COMPLETED') && <Button disabled={(simObj.laststate?.quantityordered == 0 && simObj?.currentstep == 0) ? true : false} btnName={simObj.currentstep == 0 ? 'Start Simulation' : 'Resume Simulation'} clickEventHandler={playSimulation} btnId="playSumButton" btnClass={`${(qmPopup?.pauseSimulation) ? `show ${QmModuleStyle['show']}` : ''}'`} btnParentStyle={qmPopup?.pauseSimulation ? popupStyle : {}} />
          }{
            (simObj.status == 'COMPLETED') && <Button btnName="Show Summary" clickEventHandler={showSummary} btnId="showSummary" btnParentStyle={qmPopup?.pauseSimulation ? popupStyle : {}} />
          }
        
      </div>
      { 
          qmPopup?.pauseSimulation ? <div className={`ui pointing label ${QmModuleStyle.ui} ${QmModuleStyle.pointing} ${QmModuleStyle.label} ${QmModuleStyle['sim-btn-popup']}`} role='dialog' aria-modal="true" aria-label="Simulation progress popup" tabIndex={-1} style={{top:pauseSimulationTop+"px"}}>
              <p>If you need to take a break, Pause the Simulation to stop the days from passing. The simulation automatically pauses when you read your communications and reviews. Click Resume Simulation to start where you left off.</p>
              <div className={`${QmModuleStyle.mt10} ${QmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnParentClassName={`${QmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                  setQmPopup((prevQmPopup) => ({...prevQmPopup, ['pauseSimulation'] : false, ['kpiBox'] : true}));
                  window.$("html, body").animate({ scrollTop: 0, }, 100);
              }} />
              </div>
          </div> : ""
        }
      <div className={`${QmModuleStyle['simmsg-container']}`}>
        {
          (
            ((toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowPlaceOrder)
             || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && isShowPlaceOrder) 
             || (simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming)
             || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowPlaceOrder && (simObj.status == 'COMPLETED'))) && simObj?.currentstep != 1 && <div className={`ui success message ${QmModuleStyle.ui} ${QmModuleStyle.success} ${QmModuleStyle.message} ${QmModuleStyle.simmsg}`}>
            <div role='alert'>
              { 
                (toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && (<><img src={info} alt="info" /><p>{`Pause the simulation to make a new decision.`}</p></>)
              }
              {
                !(toggleSimulation) && (isShowPlaceOrder) && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && (<><img src={info} alt="info" /><p className='placeorder-msg'>{`Your investment decisions are saved, please click on ${simObj?.currentstep > 0 ? 'Resume' : 'Start'} Simulation to continue.`}</p></>)
              }
              {                
                (simObj.status != 'COMPLETED') &&  simObj.currentstep != 0 && (!(toggleSimulation) && !(isShowPlaceOrder) && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming) && (<><img src={info} alt="info" /><p>{`Please review and make investment decisions, after submitting decisions click on Resume Simulation.`}</p></>)
              }
              {
                (simObj.status == 'COMPLETED') && (<><img src={info} alt="info" /><p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p></>)
              }
            </div>
          </div>
        }
        {
            (simObj?.status != 'COMPLETED' && simObj?.currentstep == 1) ? <div className={`ui success message ${QmModuleStyle.ui} ${QmModuleStyle.success} ${QmModuleStyle.message} ${QmModuleStyle.simmsg}`}>
                  <div role='alert'>
                    {
                      (<><img src={info} alt="info" /><p>{`Simulation is started.`}</p></>)
                    }
                  </div>
            </div> : ''
              
        }
      </div>
      
    </div>
  )
}

export default SimProgress